var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    { staticClass: "requisition-crud", attrs: { method: "POST" } },
    [
      !_vm.requisition.parent_id && _vm.creatorId
        ? _c("input", {
            attrs: { name: "creator_id", type: "hidden" },
            domProps: { value: _vm.creatorId }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "is_pipeline", type: "hidden" },
        domProps: { value: _vm.isPipeline }
      }),
      _vm._v(" "),
      _c("input", {
        attrs: { name: "is_approval", type: "hidden" },
        domProps: { value: _vm.isApproval }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x items-center mb-3" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Business Unit"),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                label: "title",
                disabled: _vm.flow == "readonly",
                options: _vm.companies,
                placeholder: "eg. Vodacom"
              },
              on: {
                search: _vm.fetchCompanies,
                open: _vm.fetchCompanies,
                input: _vm.companyInput
              },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.company }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.title) +
                          "\n                "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.company,
                callback: function($$v) {
                  _vm.company = $$v
                },
                expression: "company"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Business Unit",
                        _vm.company.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c(
              "label",
              {
                class:
                  _vm.flow == "readonly" || _vm.company === null
                    ? "readonly"
                    : ""
              },
              [_vm._v("Line of Business"), _c("sup", [_vm._v("*")])]
            ),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly" || _vm.company === null,
                label: "title",
                options: _vm.businessLines,
                placeholder: "eg. Billing, Repairs"
              },
              on: {
                search: _vm.fetchBusinessLines,
                open: _vm.fetchBusinessLines,
                input: _vm.businessLineInput
              },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.businessLine }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.businessLine,
                callback: function($$v) {
                  _vm.businessLine = $$v
                },
                expression: "businessLine"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Line of Business",
                        _vm.businessLine.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c(
              "label",
              {
                class:
                  _vm.flow == "readonly" || _vm.company === null
                    ? "readonly"
                    : ""
              },
              [_vm._v("Job Profile"), _c("sup", [_vm._v("*")])]
            ),
            _vm._v(" "),
            _vm.flow != "readonly" && _vm.jobProfile
              ? _c("input", {
                  attrs: { name: "job_profile_id", type: "hidden" },
                  domProps: { value: _vm.jobProfile.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly" || _vm.company === null,
                label: "full_title_with_external_requisition_number",
                options: _vm.jobProfiles,
                placeholder: "Select one"
              },
              on: { search: _vm.fetchJobProfiles, open: _vm.fetchJobProfiles },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.jobProfile }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.jobProfile,
                callback: function($$v) {
                  _vm.jobProfile = $$v
                },
                expression: "jobProfile"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Job Profile",
                        _vm.jobProfile.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.jobProfile
        ? _c("job-profile-readonly", {
            attrs: {
              "two-column": _vm.twoColumn,
              compact: _vm.jobProfileCompact,
              expand: _vm.expandedReadonly,
              "job-profile": _vm.jobProfile,
              inputsClickable: _vm.inputsClickable,
              "readonly-grid-position": _vm.gridPosition
            },
            on: {
              "input-clicked": function(title, val) {
                return _vm.$emit("input-clicked", title, val)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x my-4 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c(
              "label",
              {
                class:
                  _vm.flow == "readonly" || _vm.businessLine === null
                    ? "readonly"
                    : ""
              },
              [_vm._v("Person Specification"), _c("sup", [_vm._v("*")])]
            ),
            _vm._v(" "),
            _vm.flow != "readonly" && _vm.personSpecification
              ? _c("input", {
                  attrs: { name: "person_specification_id", type: "hidden" },
                  domProps: { value: _vm.personSpecification.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly" || _vm.businessLine === null,
                label: "full_title",
                options: _vm.personSpecifications,
                placeholder: "Select one"
              },
              on: { search: _vm.fetchPersonSpecs, open: _vm.fetchPersonSpecs },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.personSpecification }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.personSpecification,
                callback: function($$v) {
                  _vm.personSpecification = $$v
                },
                expression: "personSpecification"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Person Specification",
                        _vm.personSpecification.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.personSpecification
        ? _c("person-spec-readonly", {
            attrs: {
              "two-column": _vm.twoColumn,
              compact: _vm.compact,
              expand: _vm.expandedReadonly,
              "person-specification": _vm.personSpecification,
              inputsClickable: _vm.inputsClickable,
              "questions-class": _vm.questionsClass
            },
            on: {
              "input-clicked": function(title, val) {
                return _vm.$emit("input-clicked", title, val)
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Province"),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _vm.province
              ? _c("input", {
                  attrs: { name: "province_id", type: "hidden" },
                  domProps: { value: _vm.province.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly",
                label: "title",
                options: _vm.provinces
              },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.province }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _vm._v(
                        "\n                " +
                          _vm._s(option.title) +
                          "\n            "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.province,
                callback: function($$v) {
                  _vm.province = $$v
                },
                expression: "province"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Province",
                        _vm.requisition.province.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c(
              "label",
              {
                class:
                  _vm.flow == "readonly" || _vm.marketRelated == true
                    ? "readonly"
                    : ""
              },
              [_vm._v("Seats")]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requisition.seats,
                  expression: "requisition.seats"
                }
              ],
              staticClass: "mb-0",
              attrs: {
                disabled: _vm.flow == "readonly",
                name: "seats",
                type: "number",
                step: "1",
                min: "0"
              },
              domProps: { value: _vm.requisition.seats },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.requisition, "seats", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors["seats"] !== undefined
              ? _c(
                  "div",
                  { staticClass: "is-invalid-label" },
                  [
                    _vm._l(_vm.errors["seats"], function(error) {
                      return _c("small", { key: "seats" + error }, [
                        _vm._v(" " + _vm._s(error))
                      ])
                    }),
                    _c("br")
                  ],
                  2
                )
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink mb-2" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Seats",
                        _vm.requisition.seats
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-6"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Area")
            ]),
            _vm._v(" "),
            _vm.flow == "write"
              ? _c("RedactorControl", {
                  attrs: {
                    name: "area",
                    value: _vm.requisition ? _vm.requisition.area : "",
                    rows: "5"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.flow == "readonly"
              ? _c("div", {
                  staticClass: "html-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.removePTag(_vm.requisition.area))
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Area",
                        _vm.requisition.area
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c(
              "label",
              {
                class:
                  _vm.flow == "readonly" || _vm.marketRelated == true
                    ? "readonly"
                    : ""
              },
              [_vm._v("Salary"), _c("sup", [_vm._v("*")])]
            ),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.requisition.salary,
                  expression: "requisition.salary"
                }
              ],
              staticClass: "mb-0",
              attrs: {
                disabled: _vm.marketRelated == true || _vm.flow == "readonly",
                required: "",
                name: "salary",
                type: "number",
                step: "500",
                min: "0"
              },
              domProps: { value: _vm.requisition.salary },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.requisition, "salary", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _vm.errors["salary"] !== undefined
              ? _c(
                  "div",
                  { staticClass: "is-invalid-label" },
                  [
                    _vm._l(_vm.errors["salary"], function(error) {
                      return _c("small", { key: "salary" + error }, [
                        _vm._v(" " + _vm._s(error))
                      ])
                    }),
                    _c("br")
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.flow == "write"
              ? [
                  _vm.marketRelated
                    ? _c("input", {
                        attrs: {
                          name: "salary",
                          type: "hidden",
                          value: "10000"
                        }
                      })
                    : _c("input", {
                        attrs: {
                          name: "is_market_related",
                          value: "0",
                          type: "hidden"
                        }
                      })
                ]
              : _vm._e()
          ],
          2
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink mb-2" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Salary",
                        _vm.requisition.is_market_related
                          ? "Market Related"
                          : _vm.requisition.salary
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("\n                Is Market Related?\n                "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.marketRelated,
                    expression: "marketRelated"
                  }
                ],
                attrs: {
                  disabled: _vm.flow == "readonly",
                  name: "is_market_related",
                  value: "1",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.marketRelated)
                    ? _vm._i(_vm.marketRelated, "1") > -1
                    : _vm.marketRelated
                },
                on: {
                  change: [
                    function($event) {
                      var $$a = _vm.marketRelated,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = "1",
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.marketRelated = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.marketRelated = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.marketRelated = $$c
                      }
                    },
                    function(event) {
                      return event.target.checked
                        ? (_vm.requisition.salary = 10000)
                        : null
                    }
                  ]
                }
              })
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v(
                "\n                Is Evergreen Job Requisition?\n                "
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.isEvergreen,
                    expression: "isEvergreen"
                  }
                ],
                attrs: {
                  disabled: _vm.flow == "readonly",
                  name: "is_evergreen",
                  value: "1",
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.isEvergreen)
                    ? _vm._i(_vm.isEvergreen, "1") > -1
                    : _vm.isEvergreen
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.isEvergreen,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = "1",
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.isEvergreen = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.isEvergreen = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.isEvergreen = $$c
                    }
                  }
                }
              })
            ])
          ]
        ),
        _vm._v(" "),
        _vm.inputsClickable && _vm.isEvergreen
          ? _c("div", { staticClass: "cell shrink auto" }, [
              _c(
                "div",
                {
                  staticClass: "add-button",
                  on: {
                    click: function() {
                      return _vm.$emit("input-clicked", "Evergreen", "")
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", [
        _c("label", { class: _vm.twoColumn ? "" : "low-opacity" }, [
          _vm._v("Remuneration Package")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "remuneration-fields" }, [
          _c(
            "div",
            {
              staticClass: "grid-x grid-padding-x mb-3",
              class: this.gridPosition
            },
            [
              _c(
                "div",
                {
                  staticClass: "cell",
                  class: _vm.compact ? "auto" : "medium-6 large-4"
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "fw-normal",
                      class: _vm.flow == "readonly" ? "readonly" : ""
                    },
                    [_vm._v("Contract Type"), _c("sup", [_vm._v("*")])]
                  ),
                  _vm._v(" "),
                  _vm.contractType
                    ? _c("input", {
                        attrs: { name: "contract_type_id", type: "hidden" },
                        domProps: { value: _vm.contractType.id }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vue-select", {
                    attrs: {
                      disabled: _vm.flow == "readonly" ? "disabled" : false,
                      label: "title",
                      options: _vm.contractTypes
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "search",
                        fn: function(ref) {
                          var attributes = ref.attributes
                          var events = ref.events
                          return [
                            _c(
                              "input",
                              _vm._g(
                                _vm._b(
                                  {
                                    staticClass: "vs__search",
                                    attrs: { required: !_vm.contractType }
                                  },
                                  "input",
                                  attributes,
                                  false
                                ),
                                events
                              )
                            )
                          ]
                        }
                      }
                    ]),
                    model: {
                      value: _vm.contractType,
                      callback: function($$v) {
                        _vm.contractType = $$v
                      },
                      expression: "contractType"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.inputsClickable
                ? _c("div", { staticClass: "cell shrink" }, [
                    _c(
                      "div",
                      {
                        staticClass: "add-button pt-23",
                        on: {
                          click: function() {
                            return _vm.$emit(
                              "input-clicked",
                              "Contract Type",
                              _vm.requisition.contract_type.title
                            )
                          }
                        }
                      },
                      [_c("i", { staticClass: "fas fa-plus-circle" })]
                    )
                  ])
                : _vm._e()
            ]
          ),
          _vm._v(" "),
          _vm.twoColumn
            ? _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["benefits"] === undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Benefits")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["benefits"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Benefits")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "benefits",
                                value: _vm.requisition
                                  ? _vm.requisition.benefits
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["benefits"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["benefits"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "benefits" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.benefits)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Benefits",
                                    _vm.requisition.benefits
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["incentives"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Incentives")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["incentives"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Incentives")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "incentives",
                                value: _vm.requisition
                                  ? _vm.requisition.incentives
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["incentives"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              _vm._l(_vm.errors["incentives"], function(error) {
                                return _c(
                                  "small",
                                  { key: "incentive" + error },
                                  [_vm._v(" " + _vm._s(error)), _c("br")]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.incentives)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Incentives",
                                    _vm.requisition.incentives
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["bonuses"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Bonuses")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["bonuses"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Bonuses")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "bonuses",
                                value: _vm.requisition
                                  ? _vm.requisition.bonuses
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["bonuses"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["bonuses"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "bonuses" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.bonuses)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Bonuses",
                                    _vm.requisition.bonuses
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["overtime"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Overtime")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["overtime"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Overtime")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "overtime",
                                value: _vm.requisition
                                  ? _vm.requisition.overtime
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["overtime"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["overtime"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "overtime" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.overtime)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Overtime",
                                    _vm.requisition.overtime
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["public_holidays_and_sundays"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Public Holidays & Sundays")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["public_holidays_and_sundays"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Public Holidays & Sundays")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "public_holidays_and_sundays",
                                value: _vm.requisition
                                  ? _vm.requisition.public_holidays_and_sundays
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["public_holidays_and_sundays"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(
                                  _vm.errors["public_holidays_and_sundays"],
                                  function(error) {
                                    return _c(
                                      "small",
                                      {
                                        key:
                                          "public_holidays_and_sundays" + error
                                      },
                                      [_vm._v(" " + _vm._s(error))]
                                    )
                                  }
                                ),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(
                                    _vm.requisition.public_holidays_and_sundays
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Public Holidays & Sundays",
                                    _vm.requisition.public_holidays_and_sundays
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "cell mb-3 medium-4" },
                      [
                        _vm.errors["leave_policy"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Leave")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["leave_policy"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Leave")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "leave_policy",
                                value: _vm.requisition
                                  ? _vm.requisition.leave_policy
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["leave_policy"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["leave_policy"], function(
                                  error
                                ) {
                                  return _c(
                                    "small",
                                    { key: "leave_policy" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.leave_policy)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Leave",
                                    _vm.requisition.leave_policy
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
            : _c("div", [
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["benefits"] === undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Benefits")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["benefits"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Benefits")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "benefits",
                                value: _vm.requisition
                                  ? _vm.requisition.benefits
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["benefits"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["benefits"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "benefits" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.benefits)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Benefits",
                                    _vm.requisition.benefits
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["incentives"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Incentives")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["incentives"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Incentives")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "incentives",
                                value: _vm.requisition
                                  ? _vm.requisition.incentives
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["incentives"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              _vm._l(_vm.errors["incentives"], function(error) {
                                return _c(
                                  "small",
                                  { key: "incentive" + error },
                                  [_vm._v(" " + _vm._s(error)), _c("br")]
                                )
                              }),
                              0
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.incentives)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Incentives",
                                    _vm.requisition.incentives
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["bonuses"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Bonuses")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["bonuses"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Bonuses")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "bonuses",
                                value: _vm.requisition
                                  ? _vm.requisition.bonuses
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["bonuses"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["bonuses"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "bonuses" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.bonuses)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Bonuses",
                                    _vm.requisition.bonuses
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["overtime"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Overtime")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["overtime"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Overtime")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "overtime",
                                value: _vm.requisition
                                  ? _vm.requisition.overtime
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["overtime"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["overtime"], function(error) {
                                  return _c(
                                    "small",
                                    { key: "overtime" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.overtime)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Overtime",
                                    _vm.requisition.overtime
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["public_holidays_and_sundays"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Public Holidays & Sundays")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["public_holidays_and_sundays"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Public Holidays & Sundays")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "public_holidays_and_sundays",
                                value: _vm.requisition
                                  ? _vm.requisition.public_holidays_and_sundays
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["public_holidays_and_sundays"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(
                                  _vm.errors["public_holidays_and_sundays"],
                                  function(error) {
                                    return _c(
                                      "small",
                                      {
                                        key:
                                          "public_holidays_and_sundays" + error
                                      },
                                      [_vm._v(" " + _vm._s(error))]
                                    )
                                  }
                                ),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(
                                    _vm.requisition.public_holidays_and_sundays
                                  )
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Public Holidays & Sundays",
                                    _vm.requisition.public_holidays_and_sundays
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "grid-x grid-padding-x mb-4",
                    class: this.gridPosition
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "cell mb-3",
                        class: _vm.compact ? "auto" : "medium-6 large-6"
                      },
                      [
                        _vm.errors["leave_policy"] == undefined
                          ? _c(
                              "label",
                              {
                                staticClass: "fw-normal",
                                class: _vm.flow == "readonly" ? "readonly" : ""
                              },
                              [_vm._v("Leave")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["leave_policy"] !== undefined
                          ? _c("label", { staticClass: "is-invalid-label" }, [
                              _vm._v("Leave")
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "write"
                          ? _c("RedactorControl", {
                              attrs: {
                                name: "leave_policy",
                                value: _vm.requisition
                                  ? _vm.requisition.leave_policy
                                  : "",
                                rows: "5"
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.errors["leave_policy"] !== undefined
                          ? _c(
                              "div",
                              { staticClass: "is-invalid-label" },
                              [
                                _vm._l(_vm.errors["leave_policy"], function(
                                  error
                                ) {
                                  return _c(
                                    "small",
                                    { key: "leave_policy" + error },
                                    [_vm._v(" " + _vm._s(error))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.flow == "readonly"
                          ? _c("div", {
                              staticClass: "html-content",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.removePTag(_vm.requisition.leave_policy)
                                )
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.inputsClickable
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c(
                            "div",
                            {
                              staticClass: "add-button pt-23",
                              on: {
                                click: function() {
                                  return _vm.$emit(
                                    "input-clicked",
                                    "Leave",
                                    _vm.requisition.leave_policy
                                  )
                                }
                              }
                            },
                            [_c("i", { staticClass: "fas fa-plus-circle" })]
                          )
                        ])
                      : _vm._e()
                  ]
                )
              ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Closing Date"),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _c("input", {
              attrs: { name: "closing_date", type: "hidden" },
              domProps: { value: _vm.closingDate }
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                disabled: _vm.flow == "readonly",
                type: "datetime-local",
                required: ""
              },
              domProps: { value: _vm.closingDate },
              on: {
                change: function(event) {
                  return (_vm.closingDate = event.target.value)
                }
              }
            })
          ]
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink mb-2" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Closing Date",
                        _vm.closingDate
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Industries"),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _vm.industry
              ? _c("input", {
                  attrs: { name: "industry_id", type: "hidden" },
                  domProps: { value: _vm.industry.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly",
                label: "title",
                options: _vm.industries
              },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.industry }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.industry,
                callback: function($$v) {
                  _vm.industry = $$v
                },
                expression: "industry"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Industry",
                        _vm.requisition.industry.title
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-6"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Extra Notes")
            ]),
            _vm._v(" "),
            _vm.flow == "write"
              ? _c("RedactorControl", {
                  attrs: {
                    name: "notes",
                    value: _vm.requisition ? _vm.requisition.notes : "",
                    rows: "5"
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.flow == "readonly"
              ? _c("div", {
                  staticClass: "html-content",
                  domProps: {
                    innerHTML: _vm._s(_vm.removePTag(_vm.requisition.notes))
                  }
                })
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Notes",
                        _vm.requisition.notes
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Cost Center"),
              _c("sup", [_vm._v("*")])
            ]),
            _vm._v(" "),
            _vm.costCenter
              ? _c("input", {
                  attrs: { name: "cost_center_id", type: "hidden" },
                  domProps: { value: _vm.costCenter.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly",
                label: "title",
                options: _vm.costCenters
              },
              on: { search: _vm.fetchCostCenters, open: _vm.fetchCostCenters },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.costCenter }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.title) +
                          "\n                "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.costCenter,
                callback: function($$v) {
                  _vm.costCenter = $$v
                },
                expression: "costCenter"
              }
            }),
            _vm._v(" "),
            _vm.errors["cost_center"] !== undefined
              ? _c(
                  "div",
                  { staticClass: "is-invalid-label" },
                  [
                    _vm._l(_vm.errors["primary_recruiter_id"], function(error) {
                      return _c(
                        "small",
                        { key: "primary_recruiter_id" + error },
                        [_vm._v(" " + _vm._s(error))]
                      )
                    }),
                    _c("br")
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Primary Recruiter*")
            ]),
            _vm._v(" "),
            _vm.primaryRecruiter
              ? _c("input", {
                  attrs: { name: "primary_recruiter_id", type: "hidden" },
                  domProps: { value: _vm.primaryRecruiter.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly",
                label: "full_name",
                options: _vm.users
              },
              on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.primaryRecruiter }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.full_name) +
                          " (" +
                          _vm._s(option.role) +
                          ")\n                "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.primaryRecruiter,
                callback: function($$v) {
                  _vm.primaryRecruiter = $$v
                },
                expression: "primaryRecruiter"
              }
            }),
            _vm._v(" "),
            _vm.errors["primary_recruiter_id"] !== undefined
              ? _c(
                  "div",
                  { staticClass: "is-invalid-label" },
                  [
                    _vm._l(_vm.errors["primary_recruiter_id"], function(error) {
                      return _c(
                        "small",
                        { key: "primary_recruiter_id" + error },
                        [_vm._v(" " + _vm._s(error))]
                      )
                    }),
                    _c("br")
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Primary Recruiter",
                        _vm.primaryRecruiter.full_name
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid-x grid-padding-x mb-3 items-center" }, [
        _c(
          "div",
          {
            staticClass: "cell",
            class: _vm.compact ? "auto" : "medium-6 large-4"
          },
          [
            _c("label", { class: _vm.flow == "readonly" ? "readonly" : "" }, [
              _vm._v("Senior Recruiter*")
            ]),
            _vm._v(" "),
            _vm.seniorRecruiter
              ? _c("input", {
                  attrs: { name: "senior_recruiter_id", type: "hidden" },
                  domProps: { value: _vm.seniorRecruiter.id }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("vue-select", {
              attrs: {
                disabled: _vm.flow == "readonly",
                label: "full_name",
                options: _vm.users
              },
              on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
              scopedSlots: _vm._u([
                {
                  key: "search",
                  fn: function(ref) {
                    var attributes = ref.attributes
                    var events = ref.events
                    return [
                      _c(
                        "input",
                        _vm._g(
                          _vm._b(
                            {
                              staticClass: "vs__search",
                              attrs: { required: !_vm.seniorRecruiter }
                            },
                            "input",
                            attributes,
                            false
                          ),
                          events
                        )
                      )
                    ]
                  }
                },
                {
                  key: "option",
                  fn: function(option) {
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(option.full_name) +
                          " (" +
                          _vm._s(option.role) +
                          ")\n                "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.seniorRecruiter,
                callback: function($$v) {
                  _vm.seniorRecruiter = $$v
                },
                expression: "seniorRecruiter"
              }
            }),
            _vm._v(" "),
            _vm.errors["senior_recruiter_id"] !== undefined
              ? _c(
                  "div",
                  { staticClass: "is-invalid-label" },
                  [
                    _vm._l(_vm.errors["senior_recruiter_id"], function(error) {
                      return _c(
                        "small",
                        { key: "senior_recruiter_id" + error },
                        [_vm._v(" " + _vm._s(error))]
                      )
                    }),
                    _c("br")
                  ],
                  2
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.inputsClickable
          ? _c("div", { staticClass: "cell shrink" }, [
              _c(
                "div",
                {
                  staticClass: "add-button pt-23",
                  on: {
                    click: function() {
                      return _vm.$emit(
                        "input-clicked",
                        "Senior Recruiter",
                        _vm.seniorRecruiter.full_name
                      )
                    }
                  }
                },
                [_c("i", { staticClass: "fas fa-plus-circle" })]
              )
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.requisition.parent_id
        ? [
            _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
              _c(
                "div",
                {
                  staticClass: "cell",
                  class: _vm.compact ? "auto" : "medium-6 large-4"
                },
                [
                  _c(
                    "label",
                    {
                      class:
                        _vm.errors["first_approver_id"] !== undefined
                          ? "is-invalid-label"
                          : ""
                    },
                    [_vm._v("Approver #1*")]
                  ),
                  _vm._v(" "),
                  _vm.firstApprover
                    ? _c("input", {
                        attrs: { name: "first_approver_id", type: "hidden" },
                        domProps: { value: _vm.firstApprover.id }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vue-select", {
                    attrs: {
                      disabled: _vm.flow == "readonly",
                      label: "full_name",
                      options: _vm.users
                    },
                    on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "search",
                          fn: function(ref) {
                            var attributes = ref.attributes
                            var events = ref.events
                            return [
                              _c(
                                "input",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "vs__search",
                                      attrs: { required: !_vm.firstApprover }
                                    },
                                    "input",
                                    attributes,
                                    false
                                  ),
                                  events
                                )
                              )
                            ]
                          }
                        },
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.full_name) +
                                  " (" +
                                  _vm._s(option.role) +
                                  ")\n                    "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      1094767478
                    ),
                    model: {
                      value: _vm.firstApprover,
                      callback: function($$v) {
                        _vm.firstApprover = $$v
                      },
                      expression: "firstApprover"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors["first_approver_id"] !== undefined
                    ? _c(
                        "div",
                        { staticClass: "is-invalid-label" },
                        [
                          _vm._l(_vm.errors["first_approver_id"], function(
                            error
                          ) {
                            return _c(
                              "small",
                              { key: "first_approver_id" + error },
                              [_vm._v(" " + _vm._s(error))]
                            )
                          }),
                          _c("br")
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
              _c(
                "div",
                {
                  staticClass: "cell",
                  class: _vm.compact ? "auto" : "medium-6 large-4"
                },
                [
                  _c(
                    "label",
                    {
                      class:
                        _vm.errors["second_approver_id"] !== undefined
                          ? "is-invalid-label"
                          : ""
                    },
                    [_vm._v("Approver #2*")]
                  ),
                  _vm._v(" "),
                  _vm.secondApprover
                    ? _c("input", {
                        attrs: { name: "second_approver_id", type: "hidden" },
                        domProps: { value: _vm.secondApprover.id }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vue-select", {
                    attrs: {
                      disabled: _vm.flow == "readonly",
                      label: "full_name",
                      options: _vm.users
                    },
                    on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "search",
                          fn: function(ref) {
                            var attributes = ref.attributes
                            var events = ref.events
                            return [
                              _c(
                                "input",
                                _vm._g(
                                  _vm._b(
                                    {
                                      staticClass: "vs__search",
                                      attrs: { required: !_vm.secondApprover }
                                    },
                                    "input",
                                    attributes,
                                    false
                                  ),
                                  events
                                )
                              )
                            ]
                          }
                        },
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.full_name) +
                                  " (" +
                                  _vm._s(option.role) +
                                  ")\n                    "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2034752764
                    ),
                    model: {
                      value: _vm.secondApprover,
                      callback: function($$v) {
                        _vm.secondApprover = $$v
                      },
                      expression: "secondApprover"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors["second_approver_id"] !== undefined
                    ? _c(
                        "div",
                        { staticClass: "is-invalid-label" },
                        [
                          _vm._l(_vm.errors["second_approver_id"], function(
                            error
                          ) {
                            return _c(
                              "small",
                              { key: "second_approver_id" + error },
                              [_vm._v(" " + _vm._s(error))]
                            )
                          }),
                          _c("br")
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
              _c(
                "div",
                {
                  staticClass: "cell",
                  class: _vm.compact ? "auto" : "medium-6 large-4"
                },
                [
                  _c(
                    "label",
                    {
                      class:
                        _vm.errors["third_approver_id"] !== undefined
                          ? "is-invalid-label"
                          : ""
                    },
                    [_vm._v("Approver #3")]
                  ),
                  _vm._v(" "),
                  _vm.thirdApprover
                    ? _c("input", {
                        attrs: { name: "third_approver_id", type: "hidden" },
                        domProps: { value: _vm.thirdApprover.id }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("vue-select", {
                    attrs: {
                      disabled: _vm.flow == "readonly",
                      label: "full_name",
                      options: _vm.users
                    },
                    on: { search: _vm.fetchUsers, open: _vm.fetchUsers },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "option",
                          fn: function(option) {
                            return [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(option.full_name) +
                                  " (" +
                                  _vm._s(option.role) +
                                  ")\n                    "
                              )
                            ]
                          }
                        }
                      ],
                      null,
                      false,
                      2161716751
                    ),
                    model: {
                      value: _vm.thirdApprover,
                      callback: function($$v) {
                        _vm.thirdApprover = $$v
                      },
                      expression: "thirdApprover"
                    }
                  }),
                  _vm._v(" "),
                  _vm.errors["third_approver_id"] !== undefined
                    ? _c(
                        "div",
                        { staticClass: "is-invalid-label" },
                        [
                          _vm._l(_vm.errors["third_approver_id"], function(
                            error
                          ) {
                            return _c(
                              "small",
                              { key: "third_approver_id" + error },
                              [_vm._v(" " + _vm._s(error))]
                            )
                          }),
                          _c("br")
                        ],
                        2
                      )
                    : _vm._e()
                ],
                1
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.requisition.parent_id != null && !_vm.hideStatus
        ? [
            _c("div", { staticClass: "grid-x grid-padding-x mb-4" }, [
              _c(
                "div",
                {
                  staticClass: "cell",
                  class: _vm.compact ? "auto" : "medium-6 large-4"
                },
                [
                  _c(
                    "label",
                    { class: _vm.flow == "readonly" ? "readonly" : "" },
                    [_vm._v("Approver Comments")]
                  ),
                  _vm._v(" "),
                  _vm.flow == "write"
                    ? _c("RedactorControl", {
                        attrs: {
                          name: "approver_comment",
                          value: _vm.requisition
                            ? _vm.requisition.approver_comment
                            : "",
                          rows: "5"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.flow == "readonly"
                    ? _c("div", {
                        staticClass: "html-content",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.removePTag(_vm.requisition.approver_comment)
                          )
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _vm.requisition.status
              ? _c("p", { staticClass: "status" }, [
                  _c("i", {
                    staticClass: "fa",
                    class:
                      _vm.requisition.status == "approved"
                        ? "fa-check"
                        : "fa-times"
                  }),
                  _vm._v(" "),
                  _c("strong", [
                    _vm._v(_vm._s(_vm._f("capitalize")(_vm.requisition.status)))
                  ])
                ])
              : _vm._e()
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.csrfToken
        ? _c("input", {
            attrs: { type: "hidden", name: "_csrfToken" },
            domProps: { value: _vm.csrfToken }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.flow !== "readonly"
        ? _c(
            "div",
            { staticClass: "grid-x grid-padding-x" },
            [
              !_vm.requisition.parent_id
                ? [
                    _vm.requisition.created == null
                      ? _c("div", { staticClass: "cell shrink" }, [
                          _c("button", {
                            ref: "formSubmitButon",
                            staticClass: "d-none",
                            attrs: { type: "submit" }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "button primary",
                              attrs: { type: "button" },
                              on: { click: _vm.submit }
                            },
                            [
                              _vm._v(
                                "\n                    Save Progress\n                "
                              )
                            ]
                          )
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell shrink" }, [
                      _c("input", {
                        attrs: { type: "hidden", name: "request_approval" },
                        domProps: { value: 1 }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button success",
                          attrs: {
                            type: "submit",
                            name: "created",
                            value: _vm.now()
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Submit For Approval\n                "
                          )
                        ]
                      )
                    ])
                  ]
                : [
                    _c("div", { staticClass: "cell shrink" }, [
                      _vm.step === "1st"
                        ? _c("input", {
                            attrs: {
                              type: "hidden",
                              name: "approver_id_field",
                              value: "first_approver"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.step === "2nd"
                        ? _c("input", {
                            attrs: {
                              type: "hidden",
                              name: "approver_id_field",
                              value: "second_approver"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.step === "Final"
                        ? _c("input", {
                            attrs: {
                              type: "hidden",
                              name: "approver_id_field",
                              value: "third_approver"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button success",
                          attrs: {
                            type: "submit",
                            name: "status",
                            value: "approved"
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Approve\n                "
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm._m(0)
                  ],
              _vm._v(" "),
              _vm._m(1)
            ],
            2
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell shrink" }, [
      _c(
        "button",
        {
          staticClass: "button alert",
          attrs: { type: "submit", name: "status", value: "declined" }
        },
        [_vm._v("\n                    Decline\n                ")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cell shrink" }, [
      _c(
        "a",
        {
          staticClass: "button cancel",
          attrs: { href: "/recruiter/requisitions/pending" }
        },
        [_vm._v("\n                Cancel\n            ")]
      )
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-501343ae", { render: render, staticRenderFns: staticRenderFns })
  }
}